import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ArrowLeft, ArrowRight } from '@outdoor-voices/ui';
import { useInView } from 'react-intersection-observer';
import { useRef, useEffect, useState } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { SCROLL } from '../../../config/constants';
import css from './index.module.scss';
import UGC from '../../../components/UGC';
import outerWidth from '../../../utils/dom/outerWidth';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Instagrams = function Instagrams(_ref) {
  var initialItems = _ref.items,
      label = _ref.label;
  var items = initialItems.filter(function (_ref2) {
    var status = _ref2.instagram.status;
    return status !== 'ARCHIVED';
  });

  var _useInView = useInView(),
      _useInView2 = _slicedToArray(_useInView, 2),
      left = _useInView2[0],
      leftInView = _useInView2[1];

  var _useInView3 = useInView(),
      _useInView4 = _slicedToArray(_useInView3, 2),
      right = _useInView4[0],
      rightInView = _useInView4[1];

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      index = _useState2[0],
      setIndex = _useState2[1];

  var firstRef = useRef(null);
  var rootRef = useRef(null);
  var total = items.length;
  var nextButtonDisabled = rightInView;
  var prevButtonDisabled = leftInView;

  var goTo = function goTo(idx) {
    var current = rootRef.current;
    setIndex(idx);
    current.scrollTo({
      left: outerWidth(firstRef.current) * idx - 36,
      behavior: 'smooth'
    });
  }; // Handle clicks on the next button


  var onNext = function onNext() {
    goTo(index + 1);
  }; // Handle clicks on the previous button


  var onPrevious = function onPrevious() {
    goTo(index - 1);
  }; // The scrolling logic


  useEffect(function () {
    var current = rootRef.current; // Timer, used to detect whether horizontal scrolling is over

    var interval = null;

    var onScroll = function onScroll() {
      clearTimeout(interval); // Renew timer

      interval = setTimeout(function () {
        var newIndex = Math.floor(current.scrollLeft / Math.floor(outerWidth(firstRef.current)));

        if (newIndex !== index && newIndex <= total - 1) {
          setIndex(newIndex);
        }
      }, 100);
    }; // Scrolling event start


    current.addEventListener(SCROLL, onScroll);
    return function () {
      clearTimeout(interval);
      current.removeEventListener(SCROLL, onScroll);
    };
  }, [firstRef, index, setIndex, total]);
  var nextButtonClass = cc([css.button, css.buttonRight, _defineProperty({}, css.disabled, nextButtonDisabled)]);
  var prevButtonClass = cc([css.button, css.buttonLeft, _defineProperty({}, css.disabled, prevButtonDisabled)]);
  return /*#__PURE__*/_jsxs("section", {
    className: cc([css.root, _defineProperty({}, css.mobileOnly, items.length < 4)]),
    children: [/*#__PURE__*/_jsx("header", {
      className: css.header,
      children: /*#__PURE__*/_jsx("h3", {
        className: css.title,
        children: "#DoingThings"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: css.carousel,
      children: [/*#__PURE__*/_jsxs("ul", {
        "aria-label": "".concat(label, " user generated content carousel"),
        className: css.items,
        ref: rootRef // ADA compliance tab-index=0 needs noninteractive-tabindex.
        ,
        tabIndex: 0 // eslint-disable-line
        ,
        children: [/*#__PURE__*/_jsx("li", {
          "aria-hidden": "true",
          className: css.ghost,
          ref: left,
          children: "\xA0"
        }), items.map(function (item, idx) {
          return /*#__PURE__*/_jsx("li", {
            className: css.itemWrap,
            tabIndex: -1,
            ref: idx === 0 ? firstRef : null,
            children: /*#__PURE__*/_jsx("div", {
              className: css.item,
              children: /*#__PURE__*/_jsx(UGC, _objectSpread({}, item.instagram))
            })
          }, "instagram-item-".concat(item.id));
        }), /*#__PURE__*/_jsx("li", {
          "aria-hidden": "true",
          className: css.ghost,
          ref: right,
          children: "\xA0"
        })]
      }), /*#__PURE__*/_jsx("button", {
        "aria-label": nextButtonDisabled ? 'Disabled - end of carousel items' : 'Scroll to next item',
        className: nextButtonClass,
        disabled: nextButtonDisabled,
        onClick: onNext,
        type: "button",
        children: /*#__PURE__*/_jsx(ArrowRight, {})
      }), /*#__PURE__*/_jsx("button", {
        "aria-label": prevButtonDisabled ? 'Disabled - beginning of carousel items' : 'Scroll to previous item',
        className: prevButtonClass,
        disabled: prevButtonDisabled,
        onClick: onPrevious,
        type: "button",
        children: /*#__PURE__*/_jsx(ArrowLeft, {})
      })]
    })]
  });
};

Instagrams.propTypes = {
  label: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    image: PropTypes.shape({
      alt: PropTypes.string.isRequired,
      src: PropTypes.string.isRequired
    }),
    title: PropTypes.string,
    url: PropTypes.string
  })).isRequired
};
export default Instagrams;